<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="120" inline>
        <FormItem label="字典类别名称">
          <Input placeholder="请输入" v-model="table.search.DicCategroyName"></Input>
        </FormItem>
        <FormItem label="字典类别代码">
          <Input placeholder="请输入" v-model="table.search.DicCategroyCode"></Input>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="addModal=true">新增</Button>
        <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button>
      </div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal v-model="addModal" title="新增字典数据" width="60%" :footer-hide="true" :closable="false">
      <dictionaryadd @close="addModal=false" @loadData="search"></dictionaryadd>
    </Modal>

    <!--更新-->
    <Modal v-model="editModal" title="更新字典数据" width="60%" :footer-hide="true" :closable="false">
      <dictionaryedit
        v-if="editModal"
        @close="editModal=false"
        @loadData="search"
        :editModelTemp="currentEditModel"
      ></dictionaryedit>
    </Modal>

    <!--详情-->
    <Modal v-model="detailModal" title="字典数据" width="60%" :footer-hide="true" :closable="false">
      <dictionarydetail
        v-if="detailModal"
        @close="detailModal=false"
        :editModelTemp="currentEditModel"
      ></dictionarydetail>
    </Modal>

  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import dictionaryadd from "../dictionary/add.vue";
import dictionaryedit from "../dictionary/edit.vue";
import dictionarydetail from "../dictionary/detail.vue";

export default {
  components: { DataTable, dictionaryadd, dictionaryedit,dictionarydetail },
  data: function () {
    return {
      currentEditModel: {},
      detailModal: false,
      addModal: false,
      editModal: false,
      selectionData: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "字典类别名称", key: "dicCategroyName" },
          { title: "字典类别代码", key: "dicCategroyCode" },
          {
            title: "操作",
            width: "200px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.dicCategroyID);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "dictionary/getCategroyList",
        search: {
          DicCategroyName: "",
          DicCategroyCode:""
        },
      },
    };
  },

  created: function () {},
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));;
    },

    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));;
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "确认要删除该字典类别？",
        mask: false,
        onOk: () => {
          this.$api
            .post(`/dictionary/deleteDicCategroy?dicCategroyId=${id}`)
            .then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.dicCategroyID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "确认要批量删除选中的数据？",
          mask: false,
          onOk: () => {
            this.$api
              .post(`/dictionary/DeleteDicCategroyBatch?dicCategroyIds=${_ids}`)
              .then((rsp) => {
                if (rsp != false) {
                  this.$Message.success("删除成功");
                  this.search();
                }
              });
          },
        });
      }
    },

    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>